import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78e4ea52"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]




export class ContentBlock {
  type = 'link'
  label = ''
  url = ''
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ContentBlocks',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  value: ContentBlock[]
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.value, (item, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
      (item.type === 'link')
        ? (_openBlock(), _createElementBlock("a", {
            key: index,
            href: item.url
          }, _toDisplayString(item.label), 9, _hoisted_1))
        : _createCommentVNode("", true)
    ], 64))
  }), 256))
}
}

})